import ServiceTemplate from '@/components/ServiceTemplate';

export default function LLC() {
  const data = {
    title: 'LLC Formation Services',
    subtitle: 'Professional LLC formation with complete compliance and ongoing support.',
    overviewTitle: 'Why Form an LLC?',
    overviewImage: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85',
    description: [
      'A Limited Liability Company (LLC) is one of the most popular business structures in the United States, offering personal liability protection, tax flexibility, and simplified management requirements.',
      'Our comprehensive LLC formation service handles all filing requirements, ensures state compliance, and provides ongoing support to help your business succeed.',
      'We streamline the entire process, from name availability checks to obtaining your EIN and preparing operating agreements.'
    ],
    benefits: [
      { title: 'Personal Asset Protection', description: 'Shield personal assets from business liabilities and debts.' },
      { title: 'Tax Flexibility', description: 'Choose how your LLC is taxed - as sole proprietor, partnership, or corporation.' },
      { title: 'Simple Management', description: 'Fewer formalities and reporting requirements compared to corporations.' },
      { title: 'Credibility', description: 'Enhance business credibility with clients, vendors, and financial institutions.' },
      { title: 'Ownership Flexibility', description: 'No restrictions on number or types of owners.' },
      { title: 'Pass-Through Taxation', description: 'Avoid double taxation with pass-through tax treatment.' }
    ],
    process: [
      { title: 'Business Name Check', description: 'Verify availability and reserve your desired LLC name.' },
      { title: 'File Articles', description: 'Prepare and file Articles of Organization with your state.' },
      { title: 'EIN & Licenses', description: 'Obtain federal EIN and identify required business licenses.' },
      { title: 'Operating Agreement', description: 'Draft comprehensive operating agreement for your LLC.' }
    ],
    faqs: [
      { question: 'How long does LLC formation take?', answer: 'Most states process LLC filings within 7-14 business days, though expedited processing is available in many states.' },
      { question: 'What are the ongoing requirements?', answer: 'Annual reports, franchise taxes (in some states), and maintaining registered agent service are typical ongoing requirements.' },
      { question: 'Do I need an operating agreement?', answer: 'While not always legally required, an operating agreement is strongly recommended to establish management structure and ownership rights.' },
      { question: 'Can a single person form an LLC?', answer: 'Yes, most states allow single-member LLCs, providing liability protection for solo entrepreneurs.' },
      { question: 'How much does it cost?', answer: 'State filing fees typically range from $50-$500, plus our service fee. Exact costs vary by state.' },
      { question: 'What is a registered agent?', answer: 'A registered agent receives legal documents on behalf of your LLC. We can serve as your registered agent.' },
      { question: 'Can I be my own registered agent?', answer: 'Yes, but you must maintain a physical address during business hours. Many businesses prefer professional registered agent services.' },
      { question: 'How is an LLC taxed?', answer: 'By default, single-member LLCs are taxed as sole proprietorships, and multi-member LLCs as partnerships. You can elect corporate taxation if beneficial.' }
    ],
    whyChoose: {
      title: 'Why Choose LLC Formation?',
      subtitle: 'LLCs offer the perfect balance of protection, flexibility, and simplicity for most businesses',
      reasons: [
        {
          icon: '🛡️',
          title: 'Maximum Protection',
          description: 'Separate your personal assets from business liabilities with strong legal protection that shields your personal wealth.'
        },
        {
          icon: '💰',
          title: 'Tax Benefits',
          description: 'Enjoy pass-through taxation while maintaining flexibility to choose how your LLC is taxed for optimal tax savings.'
        },
        {
          icon: '⚡',
          title: 'Simple Management',
          description: 'Fewer formalities than corporations mean you can focus on growing your business instead of paperwork.'
        }
      ]
    },
    whoNeedsThis: {
      title: 'Who Needs LLC Formation?',
      description: 'An LLC is ideal for entrepreneurs, small business owners, and professionals seeking liability protection without corporate complexity.',
      image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0',
      examples: [
        {
          title: 'Startups & Entrepreneurs',
          description: 'Launching a new business and need affordable liability protection with tax flexibility.'
        },
        {
          title: 'Small Business Owners',
          description: 'Operating a growing business and want to protect personal assets from business risks.'
        },
        {
          title: 'Freelancers & Consultants',
          description: 'Independent professionals seeking credibility and legal protection for their practice.'
        },
        {
          title: 'Real Estate Investors',
          description: 'Property owners looking to separate personal liability from investment properties.'
        }
      ]
    },
    whatYouGet: {
      title: 'What\'s Included in Our Service',
      subtitle: 'Complete LLC formation package with everything you need to establish your business',
      deliverables: [
        {
          icon: '📋',
          title: 'Name Availability Search',
          description: 'We verify your desired LLC name is available and complies with state requirements.'
        },
        {
          icon: '📄',
          title: 'Articles of Organization',
          description: 'Professional preparation and filing of formation documents with your state.'
        },
        {
          icon: '🆔',
          title: 'EIN Application',
          description: 'Federal Employer Identification Number obtained from the IRS for your LLC.'
        },
        {
          icon: '📝',
          title: 'Operating Agreement',
          description: 'Comprehensive operating agreement tailored to your business structure and needs.'
        },
        {
          icon: '🏢',
          title: 'Registered Agent Service',
          description: 'First year of registered agent service included for receiving legal documents.'
        },
        {
          icon: '✅',
          title: 'Compliance Guidance',
          description: 'Detailed instructions for maintaining your LLC and meeting ongoing requirements.'
        }
      ]
    }
  };

  return <ServiceTemplate {...data} />;
}
